export default __webpack_public_path__ + "static/Chemical-05548df9d6e95c9eb0eedb69fdd45c3d.jpg";